<template>
    <div class="article-about">
        <p>
            <strong>GSC Tanker Care</strong> was founded to bridge the gap between shipowners and premium cleaning
            services. While we coordinate the logistics and customer service,
            <strong>ZHOUSHAN GOLDEN OCEAN TANKER CLEANING</strong> delivers the operational expertise needed to meet the
            highest industry standards.
        </p>
        <p>We pride ourselves on:</p>
        <ul>
            <li>
                <strong>Efficiency:</strong>
                Minimising downtime with prompt and professional service.
            </li>
            <li>
                <strong>Compliance:</strong>
                Ensuring adherence to environmental regulations.
            </li>
            <li>
                <strong>Sustainability:</strong>
                Managing waste responsibly to protect marine ecosystems.
            </li>
        </ul>
        <p>
            Our mission is to provide seamless solutions that allow shipowners to focus on their core operations while
            we handle the rest.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleAbout',
};
</script>
